import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { presentFormatedData, presentDate } from '../../../functionalComponents/dataFormatFunctions';

const useStyles = makeStyles((theme) => ({
  font: {
    fontWeight: 600,
    textAlign: 'initial',
    paddingBottom: '0.25rem',
    fontSize: '1rem',
  },
  fontPadding: {
    textAlign: 'initial',
    overflow: 'auto',
    paddingTop: '0.25rem',
    fontSize: '1rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  rowContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const PreShipmentInformation = (props) => {
  const classes = useStyles();
  const { batchDetails, selectedBatch } = props;
  

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={8} sm={12} md={12} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            Pre-Shipment Information
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails?.readyForDispatchQuantity !== null && batchDetails?.readyForDispatchQuantity !== undefined && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Quantity to be Shipped
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails?.readyForDispatchQuantity)}
              </Typography>
            </Grid>
          )}
          {batchDetails?.uomQA !== null && batchDetails?.uomQA !== undefined && batchDetails?.uomQA !== '' && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                UoM
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails?.uomQA)}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.cmoInvoiceNumber && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                CMO Invoice Number
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.cmoInvoiceNumber)}
              </Typography>
            </Grid>
          )}
          {batchDetails.cmoInvoiceDate && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                CMO Invoice Date
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentDate(batchDetails.cmoInvoiceDate)}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.grossWeight && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Gross Weight
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.grossWeight)}
              </Typography>
            </Grid>
          )}
          {batchDetails.netWeight && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Net Weight
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.netWeight)}
              </Typography>
            </Grid>
          )}
          {batchDetails.tempRangeAndSetPoint && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Temperature Range and Set Point
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.tempRangeAndSetPoint)}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.palletDimensions && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Pallet Dimensions
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.palletDimensions)}
              </Typography>
            </Grid>
          )}
          {batchDetails.noOfPallets && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Number of Pallets
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.noOfPallets)}
              </Typography>
            </Grid>
          )}
          {batchDetails.noOfCartons && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Number of Cartons
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.noOfCartons)}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.pickUpLocation && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Pickup Location
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.pickUpLocation)}
              </Typography>
            </Grid>
          )}
          {batchDetails.shipTo && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Ship To
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.shipTo)}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <hr />
    </React.Fragment>
  );
};

export default PreShipmentInformation;